import { IconCircleDashedX, IconProgressCheck, IconRefreshDot } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../components/DataTable/TableComponent';
import DropDown from '../../components/DropDown/DropDown';
import TableImage from '../../components/ImageComponent/TableImage';
import SearchComponent from '../../components/Search/SearchComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { dateTimeConverter } from '../../utils/dateTimeConverter';

const WithdrawRequests = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [searchData, setSearchData] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [cardData, setCardData] = useState(null);
    const [loading, setLoading] = useState(true);

    const statusList = [
        {
            id: null,
            name: "All",
            color: "primary"
        }, {
            id: 1,
            name: "Pending",
            color: "warning"
        }, {
            id: 2,
            name: "Completed",
            color: "success"
        }, {
            id: 3,
            name: "Failed",
            color: "danger"
        }, {
            id: 4,
            name: "Canceled",
            color: "danger"
        }
    ]

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getList() {
        loadingShow();
        let statusFilterLocal = statusList?.find(item => item?.name == statusFilter);
        let url = `${urlApi.getWithdrawRequests}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += `&search=${searchData}`
        }
        if (statusFilterLocal?.id) {
            url += `&filterByStatus=${statusFilterLocal ? statusFilterLocal?.id : null}`
        }
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }

    async function getCardsData() {
        setLoading(true);
        let resp = await getApi(urlApi.withdrawRequestStatsCard);
        setLoading(false);
        if (resp.responseCode === 200) {
            setCardData(resp.data);
        } else {
            setCardData(null);
        }
    }

    useEffect(() => {
        // if (accessCheck(accessKeys.getUserList)) {
        getList();
        // }
    }, [activePage, perPage, searchData, statusFilter]);

    useEffect(() => {
        getCardsData();

        return () => {

        }
    }, [])


    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateWithdrawStatus}${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    function onStatusFilterChange(status) {
        setActivePage(1);
        setStatusFilter(status)
    }

    function resetAll() {
        setActivePage(1);
        setPerPage(10);
        setSearchData(null);
        setStatusFilter(null);
        document.getElementById("user-table-search").value = "";
        getCardsData();
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.name, cell: (row) => (
                <Link to={"/user/" + row?.userId}>
                    <div className='flex items-center gap-2 py-2'>
                        <TableImage imageUrl={row?.userProfilePic} altText={row?.userName} />
                        <div className='text-center'>
                            <p className='fw-bold'>{row?.userName}</p>
                        </div>
                    </div>
                </Link>
            ),
        },
        { name: "Mobile", center: "true", selector: (row) => row?.phone, cell: (row) => (<span> {row?.phone ?? "--"}</span>), },
        {
            name: "Created", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>{dateTimeConverter(row?.createdAt)}</p>
        }, {
            name: "Bank", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <div>
                    <p className=''>AC No. : <span className='font-semibold'>{row?.bankAccountNumber} </span> </p>
                    <p className=''>Name : <span className='font-semibold'> {row?.bankAccountHolderName}</span> </p>
                    <p className=''>IFSC :<span className='font-semibold'> {row?.bankIFSCCode}</span> </p>
                </div>
        },
        {
            name: "Amount", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p className='font-semibold'>₹ {row?.amount || 0} </p>
        },

        {
            name: "Status", center: "true", selector: (row) => row?.status, cell: (row) =>
                <div className='flex !gap-3 flex-wrap'>
                    {row?.transactionStatus == 1 && <ConfirmationModal
                        buttonComponent={<IconButton icon={<IconProgressCheck stroke={3} className='text-green-600 cursor-pointer transition-all' />} />}
                        confirmationText={`Are You Sure Want To Approve this withdraw request ?`}
                        onConfirm={() => updateStatus(row?._id, 2)}
                    />}
                    {row?.transactionStatus == 1 && <ConfirmationModal
                        buttonComponent={<IconButton icon={<IconCircleDashedX stroke={3} className='text-red-600 cursor-pointer transition-all' />} />}
                        confirmationText={`Are You Sure Want To Reject this withdraw request ?`}
                        onConfirm={() => updateStatus(row?._id, 4)}
                    />}

                    {row?.transactionStatus != 1 && <Badge bg={statusList?.find(item => item.id == row?.transactionStatus)?.color}>{statusList?.find(item => item.id == row?.transactionStatus)?.name}</Badge>}
                </div>
        }
    ];
    return (
        <Layout>
            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>Withdraw Requests</h1>
            </div>

            <div className="flex items-center !gap-3 flex-wrap mb-3">
                <StatsCard title={"TOTAL APPROVED"} loadingState={loading} icon={"/images/users.svg"} value={"₹" + cardData?.totalData?.approved || '0'} colorCode={'text-[#144EE3]'} accentColor={'bg-[#144EE310]'} />
                <StatsCard title={"TOTAL PENDING"} loadingState={loading} icon={"/images/link.svg"} value={"₹" + cardData?.totalData?.pending || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />
                <StatsCard title={"APPROVED TODAY"} loadingState={loading} icon={"/images/qr-yellow.svg"} value={"₹" + cardData?.todayData?.approved || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />
                <StatsCard title={"PENDING TODAY"} loadingState={loading} icon={"/images/page-click.svg"} value={"₹" + cardData?.todayData?.pending || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />
            </div>

            {/* {accessCheck(accessKeys.getUserList) && */}
            <div className='flex mb-3 justify-between items-center flex-wrap gap-2'>
                <SearchComponent onClear={() => { document.getElementById("user-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("user-table-search")?.value); setActivePage(1) }} inputId='user-table-search' placeholder={"Name / Mobile / Email"} />
                <div className='ms-auto'>
                    <DropDown title={"Status"} list={statusList?.map(item => item?.name)} defaultValue={statusFilter} onSelect={(name) => onStatusFilterChange(name)} />
                </div>
                <div className='ms-[auto] md:ms-0'>
                    <IconRefreshDot className='cursor-pointer text-[var(--secondary-gradient-1)]' onClick={() => resetAll()} />
                </div>
            </div>
            {/* } */}

            {/* {accessCheck(accessKeys.getUserList) && */}
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />
            {/* } */}
        </Layout>
    )
}

export default WithdrawRequests;

export const StatsCard = ({ title, icon, value, colorCode, accentColor, loadingState }) => {
    return (
        <div className={`${accentColor} py-3 px-5 rounded-lg text-center`}>
            <img src={process.env.PUBLIC_URL + icon} alt="" />
            {loadingState ? <div className={`animate-pulse ${accentColor} rounded-lg w-[100%] h-[38px]`}></div> : <p className={`mb-0 text-[25px] font-bold text-[var(--black)]`}>{value}</p>}
            <p className={`mb-0 text-[12px] font-semibold ${colorCode}`}>{title}</p>

        </div>
    )
}